import { create } from "zustand";
import { persist } from "zustand/middleware";

type KuperModalStore = {
  wasKuperModalShown: boolean;
  disableKuperModal: () => void;
};

export const useKuperModalStore = create<KuperModalStore>()(
  persist(
    (set, get) => ({
      wasKuperModalShown: false,

      disableKuperModal: () =>
        set({
          wasKuperModalShown: true,
        }),
    }),
    {
      name: "kuper-modal-store",
    }
  )
);
